import _ from 'lodash'
import config from 'scoreboard/components/config'
import Constants from './constants'
const {
	NUMBER, STABILIZE_NUMBER, GOAL_RED_FLAG,
	SCORED_MIDDLE_4_COLOR, GOAL_ONLY
} = Constants

function hasExtraColorBelow({ kpiValueType,
		standardScoringType,
		allowScoresBelowMin=config.allowScoresBelowMin }) {
	if (isStandardWithExtraColors(standardScoringType)) {
		return true
	}

	return isCustomNumber(kpiValueType) && allowScoresBelowMin
}

function hasExtraColorAbove({ kpiValueType,
		standardScoringType,
		allowScoresBelowMin=config.allowScoresBelowMin,
		allowScoresAboveMax=config.allowScoresAboveMax }) {
	if (isStandardWithExtraColors(standardScoringType)) {
		return true
	}

	if (kpiValueType === STABILIZE_NUMBER) {
		return allowScoresBelowMin
	} else if (kpiValueType === NUMBER) {
		return allowScoresAboveMax
	} else {
		return false
	}
}

function isCustomNumber(kpiValueType) {
	return _.includes(['number', 'stabilize-number'], kpiValueType)
}

function isStandardWithExtraColors(standardScoringType) {
	return _.includes([GOAL_RED_FLAG, SCORED_MIDDLE_4_COLOR, GOAL_ONLY],
		standardScoringType)
}

export { hasExtraColorAbove, hasExtraColorBelow, isCustomNumber }
